import {
  PAIR_AMOUNT_DECIMALS,
  USD_DECIMALS,
} from '@ui/constants/numbersDecimals';
import { toReadableValue } from '@ui/lib/bignumber';

import { ContractMarketInfo } from './types';

export const toMarketInfo = (v: ContractMarketInfo) => {
  return {
    ...v,
    longQty: toReadableValue(v.longQty, PAIR_AMOUNT_DECIMALS),
    shortQty: toReadableValue(v.shortQty, PAIR_AMOUNT_DECIMALS),
    lpLongAvgPrice: toReadableValue(v.lpLongAvgPrice, USD_DECIMALS),
    lpShortAvgPrice: toReadableValue(v.lpShortAvgPrice, USD_DECIMALS),
    fundingFeeRate: toReadableValue(v.fundingFeeRate, USD_DECIMALS),
    // static pair-config snapshots may lag new contract fields — never
    // crash SSR over a missing value
    lastLongAccFundingFeePerShare: toReadableValue(
      v.lastLongAccFundingFeePerShare ?? BigInt(0),
      USD_DECIMALS,
    ),
  };
};
